"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var context_1 = __importDefault(require("./context"));
var Position = prop_types_1.default.shape({
    lat: prop_types_1.default.number.isRequired,
    lng: prop_types_1.default.number.isRequired,
}).isRequired;
var KakaoMap = React.forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g;
    var listeners = React.useRef({});
    listeners.current.onClick = function onClick(e) {
        var _a;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    listeners.current.onDoubleClick = function onDoubleClick(e) {
        var _a;
        (_a = props.onDoubleClick) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    listeners.current.onRightClick = function onRightClick(e) {
        var _a;
        (_a = props.onRightClick) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    listeners.current.onMouseMove = function onMouseMove(e) {
        var _a;
        (_a = props.onMouseMove) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    listeners.current.onDrag = function onDrag() {
        var _a;
        (_a = props.onDrag) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: map.getCenter().getLat(),
                lng: map.getCenter().getLng(),
            },
        });
    };
    listeners.current.onDragStart = function onDragStart() {
        var _a;
        (_a = props.onDragStart) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: map.getCenter().getLat(),
                lng: map.getCenter().getLng(),
            },
        });
    };
    listeners.current.onDragEnd = function onDragEnd() {
        var _a;
        (_a = props.onDragEnd) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: map.getCenter().getLat(),
                lng: map.getCenter().getLng(),
            },
        });
    };
    listeners.current.onZoomStart = function onZoomStart() {
        var _a;
        (_a = props.onZoomStart) === null || _a === void 0 ? void 0 : _a.call(props, { zoomLevel: map.getLevel() });
    };
    listeners.current.onZoomChange = function onZoomChange() {
        var _a;
        (_a = props.onZoomChange) === null || _a === void 0 ? void 0 : _a.call(props, { zoomLevel: map.getLevel() });
    };
    listeners.current.onIdle = function onIdle() {
        var _a;
        (_a = props.onIdle) === null || _a === void 0 ? void 0 : _a.call(props, {
            zoomLevel: map.getLevel(),
            position: {
                lat: map.getCenter().getLat(),
                lng: map.getCenter().getLng(),
            },
            bounds: [
                { lat: map.getBounds().getSouthWest().getLat(), lng: map.getBounds().getSouthWest().getLng() },
                { lat: map.getBounds().getNorthEast().getLat(), lng: map.getBounds().getNorthEast().getLng() },
            ],
        });
    };
    listeners.current.onBoundsChanged = function onBoundsChanged() {
        var _a;
        (_a = props.onBoundsChanged) === null || _a === void 0 ? void 0 : _a.call(props, {
            bounds: [
                { lat: map.getBounds().getSouthWest().getLat(), lng: map.getBounds().getSouthWest().getLng() },
                { lat: map.getBounds().getNorthEast().getLat(), lng: map.getBounds().getNorthEast().getLng() },
            ],
        });
    };
    listeners.current.onTilesLoaded = function onTilesLoaded() {
        var _a;
        (_a = props.onTilesLoaded) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    var _h = React.useMemo(function () {
        var $mapEl = document.createElement("div");
        $mapEl.style.width = "100%";
        $mapEl.style.height = "100%";
        var latlng = new kakao.maps.LatLng(props.center.lat, props.center.lng);
        var options = {
            center: latlng,
            level: props.level,
        };
        var $map = new kakao.maps.Map($mapEl, options);
        $map.setZoomable(props.zoomable);
        $map.setDraggable(props.draggable);
        $map.setMaxLevel(props.maxLevel);
        $map.setMinLevel(props.minLevel);
        $map.setMapTypeId(kakao.maps.MapTypeId[props.baseMapType]);
        $map.setCopyrightPosition(kakao.maps.CopyrightPosition[props.copyright.position], props.copyright.reverse);
        if (props.cursor) {
            $map.setCursor(props.cursor);
        }
        if (props.bounds) {
            var sw = new kakao.maps.LatLng(props.bounds.value[0].lat, props.bounds.value[0].lng);
            var ne = new kakao.maps.LatLng(props.bounds.value[1].lat, props.bounds.value[1].lng);
            var kakaoBounds = new kakao.maps.LatLngBounds(sw, ne);
            $map.setBounds(kakaoBounds, props.bounds.paddingTop, props.bounds.paddingRight, props.bounds.paddingBottom, props.bounds.paddingLeft);
        }
        kakao.maps.event.addListener($map, "click", listeners.current.onClick);
        kakao.maps.event.addListener($map, "dblclick", listeners.current.onDoubleClick);
        kakao.maps.event.addListener($map, "rightclick", listeners.current.onRightClick);
        kakao.maps.event.addListener($map, "mousemove", listeners.current.onMouseMove);
        kakao.maps.event.addListener($map, "drag", listeners.current.onDrag);
        kakao.maps.event.addListener($map, "dragstart", listeners.current.onDragStart);
        kakao.maps.event.addListener($map, "dragend", listeners.current.onDragEnd);
        kakao.maps.event.addListener($map, "zoom_start", listeners.current.onZoomStart);
        kakao.maps.event.addListener($map, "zoom_changed", listeners.current.onZoomChange);
        kakao.maps.event.addListener($map, "idle", listeners.current.onIdle);
        kakao.maps.event.addListener($map, "bounds_changed", listeners.current.onBoundsChanged);
        kakao.maps.event.addListener($map, "tilesloaded", listeners.current.onTilesLoaded);
        return [$map, $mapEl];
    }, []), map = _h[0], mapEl = _h[1];
    React.useEffect(function () {
        if (!props.container)
            return;
        props.container.appendChild(mapEl);
        map.relayout();
    }, [props.container]);
    React.useEffect(function () {
        return function () {
            kakao.maps.event.removeListener(map, "click", listeners.current.onClick);
            kakao.maps.event.removeListener(map, "dblclick", listeners.current.onDoubleClick);
            kakao.maps.event.removeListener(map, "rightclick", listeners.current.onRightClick);
            kakao.maps.event.removeListener(map, "mousemove", listeners.current.onMouseMove);
            kakao.maps.event.removeListener(map, "drag", listeners.current.onDrag);
            kakao.maps.event.removeListener(map, "dragstart", listeners.current.onDragStart);
            kakao.maps.event.removeListener(map, "dragend", listeners.current.onDragEnd);
            kakao.maps.event.removeListener(map, "zoom_start", listeners.current.onZoomStart);
            kakao.maps.event.removeListener(map, "zoom_changed", listeners.current.onZoomChange);
            kakao.maps.event.removeListener(map, "idle", listeners.current.onIdle);
            kakao.maps.event.removeListener(map, "bounds_changed", listeners.current.onBoundsChanged);
            kakao.maps.event.removeListener(map, "tilesloaded", listeners.current.onTilesLoaded);
        };
    }, []);
    React.useEffect(function () {
        var latlng = new kakao.maps.LatLng(props.center.lat, props.center.lng);
        map.setCenter(latlng);
    }, [props.center.lat, props.center.lng]);
    React.useEffect(function () {
        map.setDraggable(props.draggable);
    }, [props.draggable]);
    React.useEffect(function () {
        if (props.cursor)
            map.setCursor(props.cursor);
    }, [props.cursor]);
    React.useEffect(function () {
        if (!props.bounds)
            return;
        var sw = new kakao.maps.LatLng(props.bounds.value[0].lat, props.bounds.value[0].lng);
        var ne = new kakao.maps.LatLng(props.bounds.value[1].lat, props.bounds.value[1].lng);
        var kakaoBounds = new kakao.maps.LatLngBounds(sw, ne);
        map.setBounds(kakaoBounds, props.bounds.paddingTop, props.bounds.paddingRight, props.bounds.paddingBottom, props.bounds.paddingLeft);
    }, [(_a = props.bounds) === null || _a === void 0 ? void 0 : _a.value.flat(Infinity).join(), (_b = props.bounds) === null || _b === void 0 ? void 0 : _b.paddingTop, (_c = props.bounds) === null || _c === void 0 ? void 0 : _c.paddingRight, (_d = props.bounds) === null || _d === void 0 ? void 0 : _d.paddingBottom, (_e = props.bounds) === null || _e === void 0 ? void 0 : _e.paddingLeft]);
    React.useEffect(function () {
        map.setMapTypeId(kakao.maps.MapTypeId[props.baseMapType]);
    }, [props.baseMapType]);
    React.useEffect(function () {
        var _a;
        // tslint:disable-next-line: forin
        for (var type in kakao.maps.MapTypeId) {
            map.removeOverlayMapTypeId(kakao.maps.MapTypeId[type]);
        }
        (_a = props.overlayMapTypes) === null || _a === void 0 ? void 0 : _a.forEach(function (type) {
            map.addOverlayMapTypeId(kakao.maps.MapTypeId[type]);
        });
    }, [props.overlayMapTypes]);
    React.useEffect(function () {
        map.setCopyrightPosition(kakao.maps.CopyrightPosition[props.copyright.position], props.copyright.reverse);
    }, [(_f = props.copyright) === null || _f === void 0 ? void 0 : _f.reverse, (_g = props.copyright) === null || _g === void 0 ? void 0 : _g.position]);
    React.useEffect(function () {
        map.setZoomable(props.zoomable);
    }, [props.zoomable]);
    React.useEffect(function () {
        if (props.level > props.maxLevel) {
            map.setLevel(props.maxLevel);
            kakao.maps.event.trigger(map, "idle", {});
        }
        map.setMaxLevel(props.maxLevel);
    }, [props.maxLevel]);
    React.useEffect(function () {
        if (props.level < props.minLevel) {
            map.setLevel(props.minLevel);
            kakao.maps.event.trigger(map, "idle", {});
        }
        map.setMinLevel(props.minLevel);
    }, [props.minLevel]);
    React.useEffect(function () {
        var options = {
            anchor: undefined,
            animate: props.levelDuration ? { duration: props.levelDuration } : undefined
        };
        map.setLevel(props.level, options);
    }, [props.levelDuration, props.level]);
    React.useImperativeHandle(ref, function () {
        return { map: map };
    });
    var _j = React.useState(false), mount = _j[0], setMount = _j[1];
    React.useEffect(function () { return setMount(true); }, []);
    return (React.createElement(context_1.default.Provider, { value: { map: map } }, mount && props.children));
});
KakaoMap.defaultProps = {
    zoomable: true,
    draggable: true,
    copyright: { position: "BOTTOMLEFT", reverse: false },
    level: 3,
    minLevel: 1,
    maxLevel: 14,
    levelDuration: 300,
    baseMapType: "ROADMAP",
    overlayMapTypes: [],
};
KakaoMap.propTypes = {
    /** 지도가 표시될 HTML element */
    container: prop_types_1.default.instanceOf(HTMLElement),
    /** 지도의 중심 좌표 */
    center: Position,
    /** 커서 모양 */
    cursor: prop_types_1.default.string,
    /** 최대 확대/축소 수준 */
    maxLevel: prop_types_1.default.number,
    /** 최소 확대/축소 수준 */
    minLevel: prop_types_1.default.number,
    /** 확대/축소 수준 */
    level: prop_types_1.default.number,
    /** 확대/축소 트렌지션 시간 ( 단위 : ms ) */
    levelDuration: prop_types_1.default.number,
    /** 지도의 타입을 설정 */
    baseMapType: prop_types_1.default.oneOf(["ROADMAP", "SKYVIEW", "HYBRID"]),
    /** 지도에 오버레이할 타입을 설정 */
    overlayMapTypes: prop_types_1.default.arrayOf(prop_types_1.default.oneOf(["OVERLAY", "ROADVIEW", "TRAFFIC", "TERRAIN", "BICYCLE", "BICYCLE_HYBRID", "USE_DISTRICT"]).isRequired),
    /** 확대/축소 가능 여부 */
    zoomable: prop_types_1.default.bool,
    /** 드래그 가능 여부 */
    draggable: prop_types_1.default.bool,
    /** Copyright 위치 및 반전 */
    // copyright: React.Validator<{
    //   position: keyof IKakaoCopyrightPosition;
    //   reverse?: boolean | undefined;
    // } | null | undefined> | undefined,
    copyright: prop_types_1.default.shape({
        position: prop_types_1.default.oneOf(["BOTTOMLEFT", "BOTTOMRIGHT"]).isRequired,
        reverse: prop_types_1.default.bool,
    }),
    /** 주어진 영역이 화면 안에 전부 나타날 수 있도록 지도의 중심 좌표와 확대 수준을 설정 */
    bounds: prop_types_1.default.shape({
        value: prop_types_1.default.arrayOf(Position).isRequired,
        paddingTop: prop_types_1.default.number,
        paddingRight: prop_types_1.default.number,
        paddingBottom: prop_types_1.default.number,
        paddingLeft: prop_types_1.default.number,
    }),
    /** (e: { position: { lat: number, lng: number } }) => void */
    onClick: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onDoubleClick: prop_types_1.default.func,
    /** () => void */
    onRightClick: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onMouseMove: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onDrag: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onDragStart: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onDragEnd: prop_types_1.default.func,
    /** (e: { zoomLevel: number }) => void */
    onZoomStart: prop_types_1.default.func,
    /** (e: { zoomLevel: number }) => void */
    onZoomChange: prop_types_1.default.func,
    /** (e: { zoomLevel: number, position: { lat: number, lng: number }, bounds: [{lat: number, lng: number}, {lat: number, lng: number}] }) => void */
    onIdle: prop_types_1.default.func,
    /** () => void */
    onBoundsChanged: prop_types_1.default.func,
    /** () => void */
    onTilesLoaded: prop_types_1.default.func,
};
exports.default = KakaoMap;
